import React from 'react'
import {Box, IconButton, useMediaQuery, useTheme} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";


const BackButton = (props:any) =>{
    const theme = useTheme();
    const smScreen = useMediaQuery(theme.breakpoints.up("sm"));
    return(
        <Box
            display={smScreen ? "flex" : "block"}
            flexDirection={smScreen ? "row" : "column"}
            justifyContent={smScreen ? "space-between" : "start"}
            alignItems={smScreen ? "center" : "start"}
        >
            <IconButton style={{width: 64, height: 64, padding: 8}} onClick={props.onClick}>
                <ArrowBackIcon sx={{width: 32, height: 32}} />
            </IconButton>
        </Box>
    )
}
export default BackButton
